import { useQuery } from "@/compat/reactQuery";
import queryKeys from "../../constants/queryKeys";
import tileService from "../../services/tileService";

const useAccountsTiles = (accountExternalIds) =>
  useQuery(
    [queryKeys.accountsTiles, accountExternalIds?.join(",")],
    () => tileService.fetchTilesForAccounts(accountExternalIds),
    {
      staleTime: Infinity,
      enabled: accountExternalIds?.length > 0,
    }
  );

export default useAccountsTiles;
